import {useSelector} from 'react-redux'

/**
 * Custom React Hook to get random.org API response from state.
 * @see https://reactjs.org/docs/hooks-custom.html
 */
const useGroupInfoAPI = () => useSelector(state => state.groupInfo)

export default useGroupInfoAPI
